import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import Destaque from './components/Destaque.vue';
import FormularioContato from './components/FormularioContato.vue';

import Trabalhe from "./components/Trabalhe.vue";

import VueResource from 'vue-resource'
import TitleH2 from './components/TitleH2.vue'
import { store } from './store/mainStore'
import Vuex from 'vuex';
import VueTheMask from 'vue-the-mask';

Vue.component('destaque', Destaque);

Vue.component('formularioContato', FormularioContato);

Vue.component('titleH2', TitleH2);

Vue.component('trabalhe', Trabalhe);





Vue.use(VueResource);

Vue.use(Vuex);

Vue.use(VueTheMask);

Vue.config.productionTip = false

export const EventBus = new Vue();

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
